'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@mapbox/react-range/node_modules/react/react.js
// module id = 250
// module chunks = 0